<template>
  <div class="wg-row" :style="{height: modalHeight + 'px'}">
    <!-- Titolo + data -->
    <div class="wg-row" style="align-items:center;justify-content:space-between;">
      <div class="com-anm22-app-text-xl" style="margin-bottom:5px;">
        {{ $anm22.strLang(lang, 'New document', 'Nuova distinta') }}
      </div>
      <div class="display-flex" style="flex-wrap:nowrap;">
        <input 
            type="date"
            style="width:auto;"
            v-model.lazy="date">
        <input 
            type="time"
            style="width:auto;margin-left:10px;"
            v-model.lazy="time">
      </div>
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <!-- Lista prodotti -->
    <div class="wg-row" :style="{ height: listHeight + 'px' }">
      <w-g-list
          :sorting="false"
          :keyField="'id'"
          :headerItems="listHeader"
          :itemsToDisplay="listRows"
      >
        <template v-slot:default="{ element }">
          <div class="wg-row item-row" style="margin: 5px 0;">
            <div class="wg-col wg-xs-5 wg-sm-7" style="padding: 10px 0;">
              <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
                <div class="com-anm22-app-text-l">
                  {{ element.name }}
                </div>
              </div>
            </div>
            <div class="wg-col wg-xs-2" style="padding: 10px 0;">
              <div class="com-anm22-app-text-l" >
                {{ element.quantity + ' ' + getUom(element) }}
              </div>
            </div>
            <div class="wg-col wg-xs-5 wg-sm-3">
              <div class="wg-row" style="flex-wrap:nowrap;align-items:center;justify-content:flex-end;">
                <div 
                    class="display-flex label-button" 
                    :style="{
                      backgroundColor: '#EF5350',
                      width: windowWidth > 767 ? '36px' : '26px'
                    }" 
                    @click="update(element.id, element.variation - 1)">
                  <img 
                      :src="$anm22.icons.getWorldIcon('dash')" 
                      class="com-anm22-app-img-fixed-height-s">
                </div>
                <input 
                    type="number" 
                    :style="{
                      width: windowWidth > 767 ? '60px' : '40px',
                      textAlign: 'right',
                      fontSize: '16px'
                    }"
                    :value="element.variation" 
                    @focus="$event.target.select()"
                    @change="update(element.id, $anm22.round(Number.parseFloat($event.target.value), 2))">
                <div 
                    class="display-flex label-button" 
                    :style="{
                      backgroundColor: '#66BB6A',
                      width: windowWidth > 767 ? '36px' : '26px'
                    }" 
                    @click="update(element.id, element.variation + 1)">
                  <img 
                      :src="$anm22.icons.getWorldIcon('add')" 
                      class="com-anm22-app-img-fixed-height-m">
                </div>
              </div>
            </div>
          </div>
        </template>
      </w-g-list>
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <div class="wg-row" style="justify-content:center;">
      <input 
        type="button" 
        :value="$anm22.strLang(lang, 'Confirm', 'Conferma')"
        @click="save">
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import WGList from '../../../../../world/spa/components/WGList.vue';

export default {
  props: {
    license: {
      type: Object,
      required: true
    },
    timezone: {
      type: String,
      required: true
    }
  },
  components: {
    WGList
  },
  data() {
    return {
      date: this.$moment.tz(this.timezone).format('YYYY-MM-DD'),
      time: this.$moment.tz(this.timezone).format('HH:mm'),
      rows: []
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      lang: state => state.lang,
      licenseSelected: state => state.licenseSelected,
      windowHeight: state => state.windowHeight,
      windowWidth: state => state.windowWidth
    }),
    modalHeight() {
      return Math.floor(this.windowHeight * 0.9 - 90);
    },
    listHeight() {
      return this.modalHeight - 98;
    },
    products() {
      return this.$store.getters['foodProducts/getByLicense'](this.license.id)
        .filter(p => !p.deleted && p.stockType !== 1);
    },
    listHeader() {
      return [
        {
          field: 'name',
          label: this.$anm22.strLang(this.lang, 'Name', 'Nome'),
          class: 'wg-xs-5 wg-sm-7',
          disabled: false,
        },
        {
          field: 'quantity',
          label: this.$anm22.strLang(this.lang, 'Amount', 'Quantità'),
          class: 'wg-xs-2',
          disabled: true,
        },
        {
          field: 'variation',
          label: this.$anm22.strLang(this.lang, 'Variation', 'Variazione'),
          class: 'wg-xs-5 wg-sm-3',
          style: { justifyContent: 'flex-end' },
          disabled: true
        }
      ]
    },
    listRows() {
      return this.rows.map(row => {
        return {
          ...row,
          'list-metadata': {
            type: 'item',
          }
        }
      });
    }
  },
  methods: {
    getUom(p) {
      if(p.stockType === 3 && p.uom) {
        return this.$anm22.tableClasses.foodUnitOfMeasurement().getById(p.uom)['typeClassLiteral'];
      } else {
        return this.$anm22.strLang(this.lang, 'pc.', 'pz.');
      }
    },
    update(id, value) {
      const row = this.rows.find(r => r.id === id);
      row.variation = value;
    },
    async save() {
      const data = this.rows.map(r => {
        return {
          product: r.id,
          variation: r.variation
        }
      });
      try {
        const response = await this.$http.post('inventory/load', {
          date: this.date,
          time: this.time,
          rows: data
        });
        this.$store.dispatch('foodProducts/update', {
          vlf: this.$vlf('foodProducts'), objs: response.data.products
        });
        this.$anm22.eventBus.$emit("world-headbar-show-message", {
          text: this.$anm22.strLang(
            this.lang,
            "Inventory updated correctly",
            "Inventario aggiornato correttamente"
          ),
          type: "confirm"
        })
        this.$emit('close');
      } catch(e) {} 
    }
  },
  created() {
    this.rows = this.products
      .map(p => {
        return {
          id: p.id,
          name: p.langName,
          quantity: p.quantity,
          uom: p.uom,
          variation: 0
        }
      });
  }
}
</script>

<style lang="scss" scoped>
.item-row {
  height: 36px;
  &:hover {
    background-color: #fff;
  }
}
.label-button {
  flex-wrap:nowrap;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  height: 36px;
  padding: 4px;
  margin: 0 3px;
  cursor: pointer;
}
</style>